import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

const prepareDataTable = results => results.map(item => ({ ...item, key: item.id }));

function* getNetworkOrders({ payload: { signal, status, invoiceStatus, searchQ, dateAfter, dateBefore, ordering, curr_page } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.networkOrders.list,
      params: {
        page: curr_page,
        ...(status ? { status } : {}),
        // Matches any of the order's invoices - an order on two appears under both chips.
        ...(invoiceStatus ? { invoice__status: invoiceStatus } : {}),
        ...(searchQ ? { search: searchQ } : {}),
        ...(dateAfter ? { order_date_after: dateAfter } : {}),
        ...(dateBefore ? { order_date_before: dateBefore } : {}),
        ...(ordering ? { ordering } : {})
      },
      signal
    });

    yield put(actions.getNetworkOrdersDone({
      dataTable: prepareDataTable(data.results),
      count: data.count,
      next: data.next,
      previous: data.previous
    }));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getNetworkOrdersFailed,
      endpoint: api.networkOrders.list.url
    });
  }
}

export const getNetworkOrdersSaga = takeEvery(types.GET_NETWORK_ORDERS_REQUEST, getNetworkOrders);
